import { useEffect, useState } from 'react';

// Mirrors the responsive tile breakpoints in global-sass/main.scss: 4 cards
// from 1200px up, 3 below.
export const WIDE_VIEWPORT_QUERY = '(min-width: 1200px)';

const getCardsPerRow = () =>
	typeof window !== 'undefined' &&
	window.matchMedia &&
	!window.matchMedia(WIDE_VIEWPORT_QUERY).matches
		? 3
		: 4;

/**
 * Number of desktop Standard Horizontal cards that fit in one row at the
 * current viewport width. Only listens for viewport changes while enabled.
 *
 * @param {boolean} enabled - whether to track the viewport
 * @returns {number} 3 or 4
 */
export const useCardsPerRow = (enabled) => {
	const [cardsPerRow, setCardsPerRow] = useState(4);

	useEffect(() => {
		if (!enabled || typeof window === 'undefined' || !window.matchMedia) {
			return () => {};
		}
		const mediaQueryList = window.matchMedia(WIDE_VIEWPORT_QUERY);
		const onChange = () => setCardsPerRow(getCardsPerRow());
		onChange();
		// Safari < 14 only supports the deprecated addListener API
		if (mediaQueryList.addEventListener) {
			mediaQueryList.addEventListener('change', onChange);
			return () => mediaQueryList.removeEventListener('change', onChange);
		}
		mediaQueryList.addListener(onChange);
		return () => mediaQueryList.removeListener(onChange);
	}, [enabled]);

	return cardsPerRow;
};
